import { CounterpartyTypeEnum } from '@talos/kyoko';

export function formatCounterpartyTypeForDisplay(type: CounterpartyTypeEnum | string | undefined): string {
  return type === CounterpartyTypeEnum.Dealer ? 'LP' : type || '';
}
